import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const AppearanceActiveSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <rect
      width="23.9362"
      height="23.9362"
      rx="11.9681"
      fill="url(#paint0_linear-appearance)"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="23.9362" height="23.9362" rx="11.9681" fill="white" />
    </mask>
    <g mask="url(#mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2201 24.1723C14.2201 24.1723 19.4325 19.2459 19.4108 19.1792C19.4108 19.1792 19.0664 18.2836 18.2843 17.8385C18.2843 17.8385 15.3596 16.3835 12.5148 16.0572H11.6487C8.80399 16.3835 5.61932 17.8443 5.61932 17.8443C4.83692 18.2892 4.47828 19.1849 4.47828 19.1849C3.91628 20.9133 3.99286 23.9362 3.99286 23.9362L14.2201 24.1723Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9345 4.98669C10.2198 5.00926 8.52513 6.28609 8.14414 7.8468V7.84833C7.90851 8.80994 7.9226 9.60588 8.19971 10.5931C8.74243 13.1684 10.284 14.9338 11.9632 14.9338C13.5936 14.9338 15.1211 13.2308 15.6822 10.792C15.9592 9.8497 16.0791 9.01399 15.7934 7.84833C15.4094 6.27641 13.6932 4.99345 11.9718 4.98669H11.9345Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear-appearance"
        x1="-11.7081"
        y1="2.48974"
        x2="2.74003"
        y2="35.2423"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9FB1E1" />
        <stop offset="1" stopColor="#6679BF" />
      </linearGradient>
    </defs>
  </SvgWrapper>
)
